export default "__VITE_ASSET__C3Xwnzs0__"